import React from 'react';
import { motion } from 'framer-motion';
import { Slide, itemVariants } from '../Slide';
import { WaydevLogo } from '../WaydevLogo';
export function SlideClose() {
  return <Slide inverted className="justify-center items-center text-center" data-id="element-89">
      <motion.div variants={itemVariants} className="max-w-4xl mx-auto mb-16" data-id="element-90">
        <h2 className="text-5xl md:text-7xl lg:text-[90px] font-serif leading-[1.05] tracking-tight mb-8" data-id="element-91">
          We are building the brain layer for enterprise engineering.
        </h2>
      </motion.div>

      <motion.div variants={itemVariants} className="text-left max-w-4xl mx-auto w-full mb-24 pt-12 border-t border-black" data-id="element-92">
        <div className="text-sm text-gray-500 uppercase tracking-widest mb-4" data-id="element-93">
          Use of Funds
        </div>
        <ul className="space-y-2 text-lg md:text-xl" data-id="element-94">
          <li data-id="element-95">→ Scale GTM for enterprise segment</li>
          <li data-id="element-96">→ Expand MCP integration ecosystem</li>
          <li data-id="element-97">→ Deepen RL models for agent orchestration</li>
        </ul>
      </motion.div>

      <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-98">
        <WaydevLogo inverted className="h-20 md:h-28 mb-6" data-id="element-99" />
        <a href="mailto:alex@waydev.co" className="text-xl font-medium hover:text-gray-600 transition-colors" data-id="element-100">
          alex@waydev.co
        </a>
      </motion.div>
    </Slide>;
}